import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Bubble, FileCard, FileCardList} from 'kpc';

var _$tmp0 = {
    'name': '封面图.png',
    'type': 'image',
    'status': 'loading',
    'width': 160,
    'height': 160,
    'loadingVariant': 'flow'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Bubble, {
            'avatar': true,
            'roleName': '你',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['attachments'] = function($super) {
                            return (
                                _$cc(FileCardList, {
                                    'items': this.get('imageFiles'),
                                    'overflow': 'scrollY'
                                })
                            );
                        }),
                        (__$blocks['attachments'] = function($super, data) {
                            var block = $blocks['attachments'];
                            var callBlock = function() {
                                return _$blocks['attachments'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['content'] = function($super) {
                            return '\n            这批参考图先帮我整理一下，挑几张更适合作为封面方向。\n        ';
                        }),
                        (__$blocks['content'] = function($super, data) {
                            var block = $blocks['content'];
                            var callBlock = function() {
                                return _$blocks['content'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Bubble, {
            'avatar': true,
            'roleName': '你',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['attachments'] = function($super) {
                            return (
                                _$cc(FileCardList, {
                                    'items': this.get('fileItems'),
                                    'overflow': 'scrollX'
                                })
                            );
                        }),
                        (__$blocks['attachments'] = function($super, data) {
                            var block = $blocks['attachments'];
                            var callBlock = function() {
                                return _$blocks['attachments'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['content'] = function($super) {
                            return '\n            这些文档和素材包也一起带上，按这个版本先出第一版脚本。\n        ';
                        }),
                        (__$blocks['content'] = function($super, data) {
                            var block = $blocks['content'];
                            var callBlock = function() {
                                return _$blocks['content'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Bubble, {
            'avatar': true,
            'roleName': 'AI 助手',
            'variant': 'plain',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['attachments'] = function($super) {
                            return (
                                _$cc(FileCard, _$tmp0)
                            );
                        }),
                        (__$blocks['attachments'] = function($super, data) {
                            var block = $blocks['attachments'];
                            var callBlock = function() {
                                return _$blocks['attachments'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ], 4, 'file-card-demo-bubble');
};